import React from 'react'
import { cn } from '@amusnet/react-ui'
import { useTranslation } from '@amusnet/translations/react'
import chevronUpSvg from '@assets/ultra-play/chevron-up.svg'

type UltraPlayBuyBonusDropdownProps = {
    isPortrait?: boolean
    isLandscape?: boolean
    value: string
    onChange: (value: string) => void
    features: Array<{ name: string; label: string }>
}

const DROPDOWN_BORDER_CLASS = 'bg-ultra-gold-border'

const UltraPlayBuyBonusDropdown: React.FC<UltraPlayBuyBonusDropdownProps> = ({ value, onChange, features }) => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = React.useState(false)
    const ref = React.useRef<HTMLDivElement>(null)

    React.useEffect(() => {
        if (!isOpen) return

        const onClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setIsOpen(false)
        }

        document.addEventListener('mousedown', onClickOutside)

        return () => document.removeEventListener('mousedown', onClickOutside)
    }, [isOpen])

    const allOptions = [{ name: 'OFF', label: t('common.off') }, ...features]
    const selected = allOptions.find((o) => o.name === value) ?? allOptions[0]

    return (
        <div ref={ref} className="relative w-[282px]">
            {/* Trigger */}
            <div className={cn('p-[2px] rounded-[12px]', DROPDOWN_BORDER_CLASS)}>
                <button
                    onClick={() => setIsOpen((o) => !o)}
                    className="w-full flex items-center justify-between bg-ultra-surface rounded-[10px] h-[58px] px-[10px]"
                >
                    <span className={cn('font-bold text-white truncate text-[30px] leading-[36px]')}>
                        {selected.label}
                    </span>
                    <img
                        src={chevronUpSvg}
                        width={50}
                        height={50}
                        alt=""
                        className={cn('flex-shrink-0 transition-transform', isOpen ? 'rotate-0' : 'rotate-180')}
                    />
                </button>
            </div>

            {/* Dropdown list — opens above */}
            {isOpen && (
                <div
                    className={cn(
                        'absolute left-0 right-0 z-20 p-[2px] rounded-[12px] bottom-[calc(100%+10px)]',
                        DROPDOWN_BORDER_CLASS
                    )}
                >
                    <div className="bg-ultra-surface rounded-[10px] overflow-hidden">
                        {allOptions.map((option) => (
                            <button
                                key={option.name}
                                onClick={() => {
                                    onChange(option.name)
                                    setIsOpen(false)
                                }}
                                className={cn(
                                    'w-full text-left font-bold text-white text-[30px] leading-[36px] px-[10px] py-[13px]',
                                    option.name === value ? 'bg-[#222222]' : 'hover:bg-[#1a1a1a]'
                                )}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default UltraPlayBuyBonusDropdown
